import {
  CalendarDateIcon,
  ContainerIcon,
  FileDownload01Icon,
} from "@vetty/icons";
import { Button, Select, Tabs, TabsItem } from "@/components";
import {
  MODELS_HISTORY_PERIOD_OPTIONS,
  MODELS_HISTORY_SCOPE_OPTIONS,
  MODELS_HISTORY_TAB_ITEMS,
  type ModelsHistoryPeriodFilter,
  type ModelsHistoryScopeFilter,
  type ModelsHistoryToolbarTab,
} from "../../_constants/models-history-toolbar.const";
import styles from "./ModelsHistoryToolbar.module.scss";

type ModelsHistoryToolbarProps = {
  tab: ModelsHistoryToolbarTab;
  period: ModelsHistoryPeriodFilter;
  scope: ModelsHistoryScopeFilter;
  onTabChange: (value: ModelsHistoryToolbarTab) => void;
  onPeriodChange: (value: ModelsHistoryPeriodFilter) => void;
  onScopeChange: (value: ModelsHistoryScopeFilter) => void;
  onExportClick: () => void;
};

export const ModelsHistoryToolbar = ({
  tab,
  period,
  scope,
  onTabChange,
  onPeriodChange,
  onScopeChange,
  onExportClick,
}: ModelsHistoryToolbarProps) => {
  return (
    <div className={styles["comp"]}>
      <div className={styles["comp__left"]}>
        <Tabs
          value={tab}
          onChange={(value) => onTabChange(value as ModelsHistoryToolbarTab)}
          variant="secondary"
          size="medium"
        >
          {MODELS_HISTORY_TAB_ITEMS.map((item) => (
            <TabsItem key={item.value} value={item.value}>
              {item.label}
            </TabsItem>
          ))}
        </Tabs>

        <div className={styles["comp__filters"]}>
          <Select
            size="medium"
            variant="secondary"
            value={period}
            startContent={<CalendarDateIcon style={{ width: 20, height: 20 }} />}
            onChange={(value) => onPeriodChange(value as ModelsHistoryPeriodFilter)}
          >
            {MODELS_HISTORY_PERIOD_OPTIONS.map((option) => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </Select>

          <Select
            size="medium"
            variant="secondary"
            value={scope}
            startContent={<ContainerIcon style={{ width: 20, height: 20 }} />}
            onChange={(value) => onScopeChange(value as ModelsHistoryScopeFilter)}
          >
            {MODELS_HISTORY_SCOPE_OPTIONS.map((option) => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </Select>
        </div>
      </div>

      <div className={styles["comp__actions"]}>
        <Button
          size="medium"
          variant="primary"
          startContent={<FileDownload01Icon style={{ width: 20, height: 20 }} />}
          onClick={onExportClick}
        >
          Export
        </Button>
      </div>
    </div>
  );
};
